import React, { useState } from "react";
import BasicDetails from "./basicDetail/basic";
import Amenities from "./Amenities";
import AdditionalDetails from "./AdditionalDetails";
import ProjectMedia from "./ProjectMedia/ProjectMedia";
import ProjectSpecifications from "./ProjectSpecifications/ProjectSpecifications";
import AboutProject from "./AboutProject/AboutProject";
import LandmarksNearby from "./LandmarksNearby/LandmarksNearby";
import FloorPricingDetails from "./FloorPricingDetails/FloorPricingDetails";
import { createProject } from "../../../services/projectService";
import { useToast } from "../../../hooks/useToast";
import { GoogleKeys } from "../../../config/google";
import { LoadScript } from "@react-google-maps/api";


const libraries = ["places","geometry"];




function AddProjectPage() {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { showError, showSuccess } = useToast()

  const [formData, setFormData] = useState({
    basicDetails: {
      projectName: "",
      projectBuilder: "",
      location: {},
      price: "",
      bhkType: "",
    },
    projectDetails: {
      price: "",
      pricePerSqft: "",
      area: "",
      totalUnits: "",
      totalTowers: "",
      projectSize: "",
      launchDate: "",
      status: "",
      bhkOptions: "",
      reraNumber: "",
    },

    media: {
      projectPictures: [], // Array for multiple images
      brochure: null, // PDF file
      projectMap: null, // Image file
    },

    specifications: [], // <-- Now an array for multiple specifications
    keyHighlights: [], // <-- Now an array for multiple highlights
    whyBuy: [],
    landmarks: [
      { category: "", places: [{ name: "", distance: "" }] },
    ],

    amenities: {
      parking: false,
      gym: false,
      swimmingPool: false,
      clubhouse: false,
      security: false,
    },

    aboutProject: "", // <-- Now stores Rich Text Data

    floorPricingDetails: [{
      floorPriceMin: "",
      floorPriceMax: "",
      superAreaMin: "",
      superAreaMax: "",
      superAreaUnit: "Sq-ft",
      floorType: "Ground Floor",
      floorMap: [],
      bathrooms: "",
      balconies: "",
      bhkType: "", // ✅ New Field Added
    }]
  });


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData({
        ...formData,
        amenities: { ...formData.amenities, [name]: checked },
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };


  const handleChange1 = (e) => {
    const { name, value, type, checked, dataset } = e.target;
    const section = dataset.section; // Section name from dataset

    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [name]: type === "checkbox" ? checked : value,
      },
    }));
  };


  const handlefloorPricingDetailsChange1 = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      floorPricingDetails: {
        ...prev.floorPricingDetails,
        [name]: type === "checkbox" ? checked : value
      }
    }));
  };

  const handlefloorPricingDetailsChange = (e, index) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => {
      const updatedFloors = [...prev.floorPricingDetails];
      updatedFloors[index] = {
        ...updatedFloors[index],
        [name]: type === "checkbox" ? checked : value
      };

      return { ...prev, floorPricingDetails: updatedFloors };
    });
  };



  const addFloor = () => {
    setFormData((prev) => ({
      ...prev,
      floorPricingDetails: [
        ...prev.floorPricingDetails,
        {
          floorPriceMin: "",
          floorPriceMax: "",
          superAreaMin: "",
          superAreaMax: "",
          superAreaUnit: "Sq-ft",
          estimatedRentMin: "",
          estimatedRentMax: "",
          floorType: "Ground Floor",
          floorMap: [],
          bathrooms: "",
          balconies: ""
        }
      ]
    }));
  };

  const removeFloor = (index) => {
    setFormData((prev) => {
      const updatedFloors = prev.floorPricingDetails.filter((_, i) => i !== index);
      return { ...prev, floorPricingDetails: updatedFloors };
    });
  };


  const handlefloorFileChange = (e, index) => {
    const files = Array.from(e.target.files);

    setFormData((prev) => {
      const updatedFloors = [...prev.floorPricingDetails];
      updatedFloors[index] = {
        ...updatedFloors[index],
        floorMap: files
      };

      return { ...prev, floorPricingDetails: updatedFloors };
    });
  };




  const handleFileChange1 = (event, field) => {
    const files = Array.from(event.target.files); // Convert FileList to an array

    setFormData((prevData) => ({
      ...prevData,
      media: {
        ...prevData.media,
        [field]: ["projectPictures", "projectLogos"].includes(field)
          ? [...(prevData.media?.[field] || []), ...files] // Append new files
          : files[0], // Keep single file for other fields
      },
    }));
  };


  const handleRemoveFile = (field, index = null) => {
    setFormData((prevData) => {
      if (["projectPictures", "projectLogos"].includes(field)) {
        // Remove the selected image from the array
        const updatedFiles = prevData.media[field].filter((_, i) => i !== index);
        return {
          ...prevData,
          media: { ...prevData.media, [field]: updatedFiles },
        };
      } else {
        // Remove single file fields like brochure & projectMap
        return {
          ...prevData,
          media: { ...prevData.media, [field]: null },
        };
      }
    });
  };


  const removeFloorTypeImage = (floorIndex, imageIndex) => {
    setFormData((prev) => {
      const updatedFloors = [...prev.floorPricingDetails];
      updatedFloors[floorIndex].floorMap.splice(imageIndex, 1);
      return { ...prev, floorPricingDetails: updatedFloors };
    });
  };

  const handleFloorCheckboxChange = (e, index) => {
    const { name, checked } = e.target;
    setFormData((prev) => {
      const updatedFloors = [...prev.floorPricingDetails];
      updatedFloors[index][name] = checked;

      // Reset EMI amount if checkbox is unchecked
      if (!checked) {
        updatedFloors[index].emiAmount = "";
      }

      return { ...prev, floorPricingDetails: updatedFloors };
    });
  };





  const handleSpecificationChange = (e, index) => {
    const updatedSpecifications = [...formData.specifications];
    updatedSpecifications[index] = e.target.value;
    setFormData({ ...formData, specifications: updatedSpecifications });
  };

  const handleAddSpecification = () => {
    setFormData({ ...formData, specifications: [...formData.specifications, ""] });
  };

  const handleRemoveSpecification = (index) => {
    const updatedSpecifications = formData.specifications.filter((_, i) => i !== index);
    setFormData({ ...formData, specifications: updatedSpecifications });
  };

  const handleHighlightChange = (e, index) => {
    const updatedHighlights = [...formData.keyHighlights];
    updatedHighlights[index] = e.target.value;
    setFormData({ ...formData, keyHighlights: updatedHighlights });
  };

  const handleAddHighlight = () => {
    setFormData({ ...formData, keyHighlights: [...formData.keyHighlights, ""] });
  };

  const handleRemoveHighlight = (index) => {
    const updatedHighlights = formData.keyHighlights.filter((_, i) => i !== index);
    setFormData({ ...formData, keyHighlights: updatedHighlights });
  };



  // Functions to handle Why Buy list
  const handleWhyBuyChange = (e, index) => {
    setFormData((prevState) => {
      const updatedWhyBuy = [...prevState.whyBuy];
      updatedWhyBuy[index] = e.target.value;
      return { ...prevState, whyBuy: updatedWhyBuy };
    });
  };

  const handleAddWhyBuy = () => {
    setFormData((prevState) => ({
      ...prevState,
      whyBuy: [...prevState.whyBuy, ""],
    }));
  };

  const handleRemoveWhyBuy = (index) => {
    setFormData((prevState) => {
      const updatedWhyBuy = prevState.whyBuy.filter((_, i) => i !== index);
      return { ...prevState, whyBuy: updatedWhyBuy };
    });
  };




  const handleEditorChange = (content) => {
    setFormData({ ...formData, aboutProject: content });
  };


  const handleLandmarkChange = (e, catIndex, field, placeIndex = null) => {
    const { value } = e.target;
    const updatedLandmarks = [...formData.landmarks];

    if (placeIndex === null) {
      updatedLandmarks[catIndex][field] = value; // Update Category Name
    } else {
      updatedLandmarks[catIndex].places[placeIndex][field] = value; // Update Place Name or Distance
    }

    setFormData({ ...formData, landmarks: updatedLandmarks });
  };

  const addLandmark = (catIndex = null) => {
    const updatedLandmarks = [...formData.landmarks];

    if (catIndex === null) {
      updatedLandmarks.push({ category: "", places: [{ name: "", distance: "" }] }); // Add New Category
    } else {
      updatedLandmarks[catIndex].places.push({ name: "", distance: "" }); // Add New Landmark to Category
    }

    setFormData({ ...formData, landmarks: updatedLandmarks });
  };

  const removeLandmark = (catIndex, placeIndex) => {
    const updatedLandmarks = [...formData.landmarks];
    updatedLandmarks[catIndex].places.splice(placeIndex, 1);

    if (updatedLandmarks[catIndex].places.length === 0) {
      updatedLandmarks.splice(catIndex, 1); // Remove Category if Empty
    }

    setFormData({ ...formData, landmarks: updatedLandmarks });
  };





  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitted Property Data:", formData);

    const payload = new FormData();
    const userId = "677d1bd9980535da5a002840"; // Example User ID

    payload.append("userId", userId);
    payload.append("basicDetails", JSON.stringify(formData.basicDetails));
    payload.append("projectDetails", JSON.stringify(formData.projectDetails));
    payload.append("specifications", JSON.stringify(formData.specifications));
    payload.append("keyHighlights", JSON.stringify(formData.keyHighlights));
    payload.append("whyBuy", JSON.stringify(formData.whyBuy));
    payload.append("landmarks", JSON.stringify(formData.landmarks));
    payload.append("amenities", JSON.stringify(formData.amenities));
    payload.append("aboutProject", formData.aboutProject); // Plain string

    // ✅ Convert floor details into an array (without images)
    const floorPricingWithoutImages = formData.floorPricingDetails.map(floor => {
      const { floorMap, ...rest } = floor; // Remove images
      return rest;
    });
    payload.append("floorPricingDetails", JSON.stringify(floorPricingWithoutImages));


    // ✅ Append Multiple Images
    formData.media.projectPictures.forEach((file) => {
      payload.append("projectPictures", file);
    });

    // ✅ Append Single Brochure (PDF)
    if (formData.media.brochure) {
      payload.append("brochure", formData.media.brochure);
    }

    // ✅ Append Single Project Map (Image)
    if (formData.media.projectMap) {
      payload.append("projectMap", formData.media.projectMap);
    }


    // ✅ Append Multiple Project Logos
    formData.media.projectLogos.forEach((file) => {
      payload.append("projectLogos", file);
    });


    // ✅ Append Floor Maps Separately
    formData.floorPricingDetails.forEach((floor, index) => {
      floor.floorMap.forEach((file) => {
        payload.append(`floorMap_${index}`, file);
      });
    });

    try {
      setLoading(true);
      const response = await createProject(payload);

      if (response.success) {
        showSuccess("Project created successfully!");
      } else {
        showError("Failed to create project");
      }
    } catch (err) {
      showError("Error creating project");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoadScript googleMapsApiKey={GoogleKeys.GOOGLE_MAPS_API_KEY} libraries={libraries}>

      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-6 my-[140px]">
        <h2 className="text-2xl font-bold mb-6 text-left">Add Project</h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <BasicDetails formData={formData} handleChange={handleChange} handleChange1={handleChange1} setFormData={setFormData} />
          <AdditionalDetails formData={formData} handleChange={handleChange1} />
          <ProjectMedia formData={formData} handleFileChange={handleFileChange1} handleRemoveFile={handleRemoveFile} />
          <ProjectSpecifications
            formData={formData}
            handleSpecificationChange={handleSpecificationChange}
            handleAddSpecification={handleAddSpecification}
            handleRemoveSpecification={handleRemoveSpecification}
            handleHighlightChange={handleHighlightChange}
            handleAddHighlight={handleAddHighlight}
            handleRemoveHighlight={handleRemoveHighlight}
            handleWhyBuyChange={handleWhyBuyChange}
            handleAddWhyBuy={handleAddWhyBuy}
            handleRemoveWhyBuy={handleRemoveWhyBuy}
          />


          <LandmarksNearby
            formData={formData}
            setFormData={setFormData}
            handleLandmarkChange={handleLandmarkChange}
            addLandmark={addLandmark}
            removeLandmark={removeLandmark}
          />

          <Amenities formData={formData} handleChange={handleChange} />

          <AboutProject
            formData={formData} handleEditorChange={handleEditorChange}
          />

          <FloorPricingDetails formData={formData} handleChange={handlefloorPricingDetailsChange} addFloor={addFloor} removeFloor={removeFloor} handleFileChange={handlefloorFileChange} removeImage={removeFloorTypeImage} handleCheckboxChange={handleFloorCheckboxChange} />

          <div className="flex justify-end space-x-4 mt-6">
            <button
              type="button"
              className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition"
              onClick={() => console.log("Cancelled")}
            >
              Cancel
            </button>

            <button
              type="submit"
              className={`bg-blue-600 text-white py-2 px-6 rounded-md shadow-sm hover:bg-blue-700 ${loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit Project"}
            </button>
          </div>
        </form>
      </div>
    </LoadScript>
  );
}

export default AddProjectPage;
